import { actions } from './actions';

const FiltersReducers = {
    [actions.APPLY_FILTERS]: (state, action) => { return { ...state, filtersSearchBox: action.filtersSearchBox } },
}

export default FiltersReducers;